import { Component, OnInit } from '@angular/core';
import {SharedService} from '../../../../../core/services/shared-service/shared.service';

@Component({
  selector: 'app-agent-support',
  templateUrl: './agent-support.component.html',
  styleUrls: ['./agent-support.component.scss']
})
export class AgentSupportComponent implements OnInit {

  private pageTitle: string;
  constructor(public _sharedService: SharedService) {
    this.pageTitle = 'Support';
    this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/pages/Dashboard/AgentDashboardPages/agent-support/agent-support.component.ts